export const FLOW_PAGE_TITLE = 'Hantera fl\u00f6den';
export const ACCOUNT_PAGE_TITLE = 'Hantera konton';
export const START_PAGE_TITLE = 'Start';

export const DEFAULT_MIN_TIMEOUT = 600;
